import { useMutation, useQueryClient } from '@tanstack/react-query';
import { saveWeeklyOffNurses } from '@api/nurses';
import { QUERY_BASE_KEY } from '@constants/query-key';
import type { SaveWeeklyOffNursePayload } from '@vTypes/weeklyOff';

interface SaveNursesParams {
    payload: SaveWeeklyOffNursePayload[];
    groupId?: string;
}

/**
 * 간호사별 주휴 설정을 저장하는 TanStack Query Mutation 훅
 * @returns TanStack Query의 `useMutation` 결과 객체 (mutate, isLoading 등)
 */
export const useSaveWeeklyOffNursesMutation = (groupId?: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ payload, groupId: mutationGroupId }: SaveNursesParams) =>
            saveWeeklyOffNurses(payload, mutationGroupId),
        onSuccess: (data, variables) => {
            const queryId = variables.groupId ?? groupId;
            // 근무표 설정에 있는 주휴 간호사 목록과 전체 간호사 목록 쿼리를 모두 무효화
            queryClient.invalidateQueries({ queryKey: [QUERY_BASE_KEY.WEEKLYOFF, 'nurses'] });
            queryClient.invalidateQueries({ queryKey: ['nurses', 'fullSchema', queryId] });
            // 근무자 관리에서 사용하는 간호사 목록 쿼리 전체 무효화
            queryClient.invalidateQueries({ queryKey: [QUERY_BASE_KEY.NURSES] });

        },
        onError: (error) => {
            console.error("간호사별 주휴 설정 저장 중 에러 발생:", error);

        },
    });
};
